<template>
    <div class="code_wrap" @click="drawCode('')" id="code">
        <canvas width="100" height="40" id="verifyCanvas"></canvas>
        <img id="code_img">
    </div>
</template>
<script>
export default {
    data() {
        return {
            nums: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "0",
                "A",
                "B",
                "C",
                "D",
                "E",
                "F",
                "G",
                "H",
                "I",
                "J",
                "K",
                "L",
                "M",
                "N",
                "O",
                "P",
                "Q",
                "R",
                "S",
                "T",
                "U",
                "V",
                "W",
                "X",
                "Y",
                "Z",
                "a",
                "b",
                "c",
                "d",
                "e",
                "f",
                "g",
                "h",
                "i",
                "j",
                "k",
                "l",
                "m",
                "n",
                "o",
                "p",
                "q",
                "r",
                "s",
                "t",
                "u",
                "v",
                "w",
                "x",
                "y",
                "z"
            ],
            str: ""
        };
    },
    mounted() {
        this.drawCode();
    },
    methods: {
        // 绘制验证码
        drawCode(str = "") {
            document.getElementById("verifyCanvas").remove();
            var box = document.getElementById("code");
            var p1 = document.getElementById("code_img");

            var p0 = document.createElement("canvas");
            p0.id = "verifyCanvas";

            box.insertBefore(p0, p1);
            p0.width = 100;
            p0.height = 40;
            var canvas = document.getElementById("verifyCanvas"); //获取HTML端画布
            var context = canvas.getContext("2d"); //获取画布2D上下文
            context.fillStyle = "#0b2744"; //画布填充色
            context.fillRect(0, 0, canvas.width, canvas.height); //清空画布
            context.fillStyle = "#fff"; //设置字体颜色
            context.font = "25px Arial"; //设置字体
            var rand = new Array();
            var x = new Array();
            var y = new Array();
            for (var i = 0; i < 4; i++) {
                rand.push(rand[i]);
                rand[i] = this.nums[
                    Math.floor(Math.random() * this.nums.length)
                ];
                x[i] = i * 20 + 10;
                y[i] = Math.random() * 20 + 20;
                context.fillText(rand[i], x[i], y[i]);
            }
            this.str = rand.join("").toUpperCase();
            // //画3条随机线
            // for (var i = 0; i < 3; i++) {
            //     this.drawline(canvas, context);
            // }

            // // 画30个随机点
            // for (var i = 0; i < 30; i++) {
            //     this.drawDot(canvas, context);
            // }
            this.convertCanvasToImage(canvas);
            this.$emit("code", this.str);
            return this.str;
        },
        // 随机线
        drawline(canvas, context) {
            context.moveTo(
                Math.floor(Math.random() * canvas.width),
                Math.floor(Math.random() * canvas.height)
            ); //随机线的起点x坐标是画布x坐标0位置，y坐标是画布高度的随机数
            context.lineTo(
                Math.floor(Math.random() * canvas.width),
                Math.floor(Math.random() * canvas.height)
            ); //随机线的终点x坐标是画布宽度，y坐标是画布高度的随机数
            context.lineWidth = 0.5; //随机线宽
            context.strokeStyle = "rgba(50,50,50,0.3)"; //随机线描边属性
            context.stroke(); //描边，即起点描到终点
        },
        // 随机点(所谓画点其实就是画1px像素的线，方法不再赘述)
        drawDot(canvas, context) {
            var px = Math.floor(Math.random() * canvas.width);
            var py = Math.floor(Math.random() * canvas.height);
            context.moveTo(px, py);
            context.lineTo(px + 1, py + 1);
            context.lineWidth = 0.2;
            context.stroke();
        },
        // 绘制图片
        convertCanvasToImage(canvas) {
            document.getElementById("verifyCanvas").style.display = "none";
            var image = document.getElementById("code_img");
            image.src = canvas.toDataURL("image/png");
            return image;
        }
    }
};
</script>
<style lang="scss" scoped>
.code_wrap {
}
</style>

